import OnboardingChecklistGuard from './OnboardingChecklistGuard';

export default {
  ReactComponent: OnboardingChecklistGuard,
  bindings: {
    positions: '<',
    locations: '<',
    employees: '<',
    currentUser: '<',
    clientFlags: '<',
    saveLaborCostSettingsInAngular: '&',
    personasDict: '<',
    orgLocationsCount: '<',
    addPersonaCollectionUser: '&',
    openCreateShiftModal: '&',
    navigateToReports: '&',
    navigateToSchedule: '&',
    updateOrgSettings: '&',
    editPersonaCollectionGroup: '&',
    onUpdateClientFlags: '&',
    isLoaded: '<',
    showPublishShiftModal: '&',
    showPublishShiftTooltip: '&',
    allEvents: '<',
    orgSettings: '<',
    autoOpenOnboarding: '<',
    updateWages: '&',
  },
};
